import { posts } from './posts';

// Category filter buttons and their colours (same palette approach as the blog)
export const tagColors: Record<string, string> = {
  'View All': 'primary',
  'Tracking': 'secondary',
  'Insights': 'info',
  'Doctor visits': 'success',
  'Widgets & shortcuts': 'accent',
};

export interface FeaturePost {
  id: string;
  image: string;
  // true for app screenshots: fills the card image and shows larger on the page
  screenshot?: boolean;
  // Optional crop for the Features card (3:1, e.g. 1158x386); falls back to `image`
  cardImage?: string;
  tag: string;
  // ISO format (YYYY-MM-DD) so it can be used directly in structured data
  date: string;
  title: string;
  subtitle: string;
  readTime: string;
  content: string;
  // Example content for building the page. Hidden in production builds, but the
  // text is still in the JS bundle, so delete placeholder files before launch.
  placeholder?: boolean;
}

export const formatFeatureDate = (isoDate: string) =>
  new Date(isoDate).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });

// Newest first, and drop placeholder pages from production builds
const featurePosts: FeaturePost[] = posts
  .filter((post) => process.env.NODE_ENV === 'development' || !post.placeholder)
  .sort((a, b) => b.date.localeCompare(a.date));

export default featurePosts;
